import React from 'react'
import Head from 'next/head'
import LegalPage from 'pages/website/LandingPage/EntrepreneurSeminar/LegalPage'
import { termsOfUse } from 'pages/website/LandingPage/EntrepreneurSeminar/legalContent'
import useJumpstartIntake from 'pages/website/LandingPage/EntrepreneurSeminar/useJumpstartIntake'
import CommonHead from '../_head'

// Old renderer, kept for revert:
// import TermsOfUse from '../../src/pages/website/TermsOfUse/TermsOfUse'

const Terms = () => {
  const onIntakeSubmit = useJumpstartIntake('jumpstart')

  return (
    <>
      <Head>
        <title>Terms of Use | Entrepreneur Seminar</title>
        <CommonHead description="The terms and conditions governing your use of Entrepreneur Seminar." />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap"
        />
      </Head>
      <LegalPage document={termsOfUse} onIntakeSubmit={onIntakeSubmit} />
    </>
  )
}

export const getServerSideProps = () => ({ props: { topNavActive: false, footerActive: false } })

export default Terms
